import { Route } from '@angular/router';
import { UNSAVED_CHANGES_GUARD } from 'src/app/_avmin/avmin.module';
import { BookingEditorComponent } from './components/editor/booking-editor.component';

export const BOOKING_ROUTES: Route[] = [
  {
    path: 'new',
    loadComponent: () => import('./components/editor/booking-editor.component').then((m) => m.BookingEditorComponent),
    canDeactivate: [async (component: BookingEditorComponent) => await UNSAVED_CHANGES_GUARD(component.form.dirty)],
  },
  {
    path: ':bookingId/edit',
    loadComponent: () => import('./components/editor/booking-editor.component').then((m) => m.BookingEditorComponent),
    canDeactivate: [async (component: BookingEditorComponent) => await UNSAVED_CHANGES_GUARD(component.form.dirty)],
  },
];
